import * as core from '../../../../../../../core'
import * as stakeholderTrainingAudience from '../stakeholder-training-audience'

export const RESOURCE = {
  payload: {
    description: 'Role-Based Training',
    enumId: core.dms.models.Enum.Id.from({
      partialId: stakeholderTrainingAudience.RESOURCE.payload.partialId,
    }),
    id: 'Role-Based Training',
    name: 'Role-Based Training',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
